import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ActionsMenuWrapper = styled.div`
  position: relative;
  margin-left: auto;
`

export const KebabIcon = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  span {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
  }
`

export const ActionsDropdown = styled.div<{ show: boolean }>`
  display: ${(p) => (p.show ? 'flex' : 'none')};
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 3rem;
  z-index: 99900009;
  min-width: 12rem;
  padding: 0.5rem;
  border: 1px solid ${tokens.border.hairline};
  border-radius: 12px;
  background-color: ${tokens.surface.raised};
`

export const ActionsDropdownItem = styled.div<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 0.75rem;
  height: 2.5rem;
  border-radius: 8px;
  cursor: pointer;
  color: ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.text.primary)};

  svg {
    fill: ${(p) => (p.$danger ? tokens.status.danger.fg : tokens.text.primary)};
  }

  &:hover {
    background-color: ${tokens.surface.inset};
  }
`

export const PhaseList = styled.div`
  display: flex;
  flex-direction: column;
`

const phaseDotSize = '1rem'
const phaseDotCenter = `calc(${phaseDotSize} / 2)`

export const PhaseItem = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
  padding-bottom: 1.5rem;
  align-items: flex-start;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: calc(${phaseDotSize} / 2 - 1px);
    top: 0;
    height: ${phaseDotCenter};
    width: 2px;
    background: ${tokens.accent.base};
    opacity: 0.5;
    z-index: 0;
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    left: calc(${phaseDotSize} / 2 - 1px);
    top: ${phaseDotCenter};
    bottom: 0;
    width: 2px;
    background: ${tokens.accent.base};
    opacity: 0.5;
    z-index: 0;
  }
`

export const PhaseIndicator = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${phaseDotSize};
`

export const PhaseDot = styled.div`
  width: ${phaseDotSize};
  height: ${phaseDotSize};
  border-radius: 50%;
  background: ${tokens.accent.base};
  flex-shrink: 0;
  position: relative;
  z-index: 1;
`

export const PhaseBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  border: 1px solid ${(p) => p.$color};
  background: ${(p) => p.$color}18;
  color: ${(p) => p.$color};
`

export const PhaseBadgeDot = styled.div<{ $color: string }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${(p) => p.$color};
`

export const EtaText = styled.span`
  font-family: 'Courier New', monospace;
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const RiskChainWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`

export const RiskChainChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const RiskChainArrow = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const RiskItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`

export const RiskConsequenceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  border-left: 3px solid ${tokens.status.warning.fg};
  border-radius: ${tokens.radius.chip};
  background: ${tokens.status.warning.bg};
`

export const RiskAppliedNote = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-left: 3px solid ${tokens.status.success.fg};
  border-radius: ${tokens.radius.chip};
  background: ${tokens.status.success.bg};
`

export const FuelSuffix = styled.span<{ $low?: boolean }>`
  margin-left: 0.375rem;
  font-size: ${tokens.font.micro};
  font-weight: 500;
  color: ${(p) => (p.$low ? tokens.status.warning.fg : tokens.text.muted)};
`

export const ResourceRow = styled.div<{ $idle?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  background: ${(p) => (p.$idle ? tokens.status.warning.bg : 'transparent')};
`
